
import { ArrowDown } from "lucide-react";
import { useEffect, useState } from "react";
import DownloadPopup from "./DownloadPopup";
import DiscordButton from "./DiscordButton";

const Hero = () => {
  const [scrollY, setScrollY] = useState(0);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  
  const scrollToNextSection = () => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'scroll_to_next', {
        event_category: 'navigation',
        event_label: 'Hero Scroll Down Button Clicked',
        section_from: 'hero',
        section_to: 'game-experience'
      });
    }
    const gameExperience = document.getElementById('game-experience');
    if (gameExperience) {
      gameExperience.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  
  return <div className="relative min-h-screen flex flex-col justify-end overflow-hidden bg-[#141414] text-white">
      {/* Dynamic parallax background */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 w-full h-full md:hidden" style={{
        backgroundImage: `url('/lovable-uploads/FRRM-Website-Paralax-01-Mobile.webp')`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        transform: `scale(${1 + scrollY * 0.0005}) translateY(${scrollY * 0.5}px)`
      }} />
        <div className="absolute inset-0 w-full h-full hidden md:block" style={{
        backgroundImage: `url('/lovable-uploads/FRRM-Website-Paralax-01.webp')`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        transform: `scale(${1 + scrollY * 0.0005}) translateY(${scrollY * 0.5}px)`
      }} />
        
        {/* Dramatic lighting/gradient overlay */}
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(to bottom, rgba(0,0,0,0) 30%, rgba(0,0,0,0.9) 100%)'
      }} />
      </div>
      
      {/* Card that extends to the bottom edge */}
      <div className="relative z-30 w-full max-w-none mt-auto">
        <div className="container mx-auto">
          {/* Floating "Welcome to" badge positioned to overlap with the card */}
          <div className="absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-40 overflow-hidden h-10" style={{
          top: "0px",
          opacity: Math.max(0, 1 - scrollY / 300)
        }}>
            <span className="bg-black/20 bg-racing-orange/10 backdrop-blur-lg text-white px-8 md:px-6 py-2 rounded-t-2xl text-sm md:text-base uppercase font-heading tracking-widest shadow-lg border border-[#555555]/20 opacity-0 flex items-center gap-2 md:gap-2 font-bold whitespace-nowrap animate-slide-up [animation-delay:0.6s]">
              <span className="inline-block w-3 md:w-5 h-[0.25px] bg-racing-orange"></span>
              Welcome to
              <span className="inline-block w-3 md:w-5 h-[0.25px] bg-racing-orange"></span>
            </span>
          </div>
          
          <div className="relative max-w-3xl mx-auto px-5 pt-12 pb-20 bg-black/50 backdrop-blur-sm rounded-t-2xl border-t border-x border-white/10 animate-fade-up opacity-0 [animation-delay:0.4s] shadow-[0_-15px_50px_-15px_rgba(0,0,0,0.7)]">
            
            {/* Logo with subtle entrance animation */}
            <div className="mt-4 mb-6 animate-fade-in opacity-0 [animation-delay:0.6s]">
              <img src="/lovable-uploads/Front-Runner-Logo.png" alt="Front Runner Logo" className="h-[5.5rem] md:h-[7rem] mx-auto" />
            </div>
            
            {/* Description with staggered fade in */}
            <p className="text-sm md:text-base text-white/90 max-w-2xl mx-auto mb-8 leading-relaxed animate-fade-in opacity-0 [animation-delay:0.8s] text-center lg:text-lg">
              Experience the thrill of horse racing like never before. Build your stable, train your horses, and compete in epic races.
            </p>
            
            {/* Action Buttons with fixed width - ensuring they're the same size */}
            <div className="flex flex-col md:flex-row gap-4 justify-center mb-12 animate-fade-in opacity-0 [animation-delay:1s]">
              <div className="w-full sm:w-[240px]">
                <DownloadPopup buttonText="Play Now" />
              </div>
              <div className="w-full sm:w-[240px]">
                <DiscordButton />
              </div>
            </div>
            
            {/* Scroll Down Arrow with pulsing effect */}
            <div onClick={scrollToNextSection} className="absolute bottom-6 left-1/2 -translate-x-1/2 cursor-pointer group z-40" style={{
            opacity: Math.max(0, 1 - scrollY / 300)
          }}>
              <div className="relative">
                <div className="absolute -inset-4 bg-racing-orange/10 rounded-full scale-0 group-hover:scale-100 transition-transform duration-300"></div>
                <ArrowDown className="w-6 h-6 md:w-7 md:h-7 text-racing-orange animate-bounce" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};

export default Hero;
